import getDataFromGoogleSheets from './data';
import createChart from './chart';
import loadRequiredFonts from './fontLoader';
import { updateProcessingTimeText } from './utils';
import { showSkeleton } from './skeletonLoader';

// import einFixture from './fixtures/data.fixture';

function createEinChart(containerId = 'ein-chart', config = {}) {
  let container = null;
  let chart = null;
  const { dataUrl, dayInterval } = config;

  const widget = {
    async init() {
      try {
        container = document.getElementById(containerId);
        if (!container) {
          throw new Error(`Element with id "${containerId}" not found`);
        }

        // Show skeleton loader while fetching data
        showSkeleton(container);

        // Test mode: keep skeleton loader visible indefinitely
        if (false) {
          return widget;
        }

        let data = null;
        for (let attempt = 1; attempt <= 3; attempt++) {
          try {
            console.log(`EIN Chart: Fetching data (attempt ${attempt}/3)...`);
            data = await getDataFromGoogleSheets(dataUrl);
            break;
          } catch (error) {
            console.error(`EIN Chart: Attempt ${attempt} failed:`, error);
            if (attempt === 3) {
              throw new Error('Failed to load chart data');
            }
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }

        if (!data || data.length === 0) {
          throw new Error('No data available');
        }

        chart = await createChart(container, data, { dayInterval });

        // Auto-update processing time text if element exists
        updateProcessingTimeText(data);

        return widget;
      } catch (error) {
        console.error('EIN Chart: Init failed:', error.message);

        // Update processing time text with error state if element exists
        try {
          const element = document.getElementById('ein-processing-time');
          if (element) {
            element.textContent = 'Data unavailable';
          }
        } catch (textError) {
          // Ignore text update errors during failure
        }

        throw error;
      }
    },

    destroy() {
      if (chart) {
        chart.destroy();
        chart = null;
      }

      container = null;
      return widget;
    },
  };

  // Initialize the Chart when `createEinChart` invoked
  widget.init().catch((error) => {
    console.error('Auto-initialization failed:', error);
  });

  return widget;
}

// Auto-initialize by default when DOM ready for zero-config usage
function autoInitDefault() {
  const initDefaultWidget = async () => {
    if (document.getElementById('ein-chart')) {
      // Pre-load fonts for auto-initialization
      await loadRequiredFonts();
      window.einChartWidget = createEinChart('ein-chart');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDefaultWidget);
  } else {
    initDefaultWidget();
  }
}

window.createEinChart = createEinChart;

autoInitDefault();

export default createEinChart;
